import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ItemSelectorServiceV2, SelectionOptions } from '@galaxy/inventory-ui';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { ActivatableItemCount, ActivationStatus, isValidEditionId } from '../../core/interface';

@Component({
  selector: 'app-activation-cart',
  templateUrl: 'activation-cart.component.html',
  styleUrls: ['activation-cart.component.scss'],
})
export class ActivationCartComponent implements OnChanges {
  @Input() appCartItems: ActivatableItemCount[];
  @Input() features: any;
  @Input() config!: SelectionOptions;

  @Output() removeApp: EventEmitter<string> = new EventEmitter();

  activatedStatus = ActivationStatus.ACTIVATED;
  cancelledStatus = ActivationStatus.CANCELED;
  newItemIds: string[];

  constructor(
    private productAnalyticsService: ProductAnalyticsService,
    private itemSelectorService: ItemSelectorServiceV2,
  ) {}

  removeAppSelected(item: ActivatableItemCount): void {
    this.itemSelectorService.removeItemId(item.activatableItem.appId, 'user', this.config);
    this.removeApp.emit(item.activatableItem.appId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.appCartItems) {
      this.newItemIds = this.getNewItemIds(changes.appCartItems.previousValue, changes.appCartItems.currentValue);
    }
  }

  showBadge(isTrial: boolean, editionId: string): boolean {
    const editionIdValid = isValidEditionId(editionId);
    return !isTrial && editionIdValid;
  }

  getNewItemIds(previousItems: ActivatableItemCount[], currentItems: ActivatableItemCount[]): string[] {
    if (currentItems && previousItems) {
      const currentIds = currentItems.map((item) => item.activatableItem.appId);
      const previousIds = previousItems.map((item) => item.activatableItem.appId);
      return currentIds.filter((id) => !previousIds.includes(id));
    } else if (currentItems) {
      return currentItems.map((item) => item.activatableItem.appId);
    }
    return [];
  }
}
